import FormCkEditorField from "./fields/Form/CkEditorField.vue"
import DetailCkEditorField from "./fields/Detail/CkEditorField.vue"

const ckEditorFieldSetup = (app) => {
    app.component('form-ck-editor-field', FormCkEditorField)
    app.component('detail-ck-editor-field', DetailCkEditorField)
}

export { ckEditorFieldSetup }
